import styles from './Actions.module.scss'
import {useEffect, useRef} from "react";
import Commercial, {CommercialType} from "@/Atoms/Commercial";
import RoundIcon from "@/Atoms/RoundIcon";
import Flower from "@/Atoms/Icons/Flower";
import Candle from "@/Atoms/Icons/Candle";
import Pen from "@/Atoms/Icons/Pen";
import {Person} from "@/types/person";
import useWindowSize from "@/helpers/useWindowSize";
import SharePerson from "@/Molecules/Socials/SharePerson";

export default function Actions(
  {
    person,
    options,
    showInteractions,
    manualHeight,
    className,
    isOpen,
    OnSetMobileState,
    OnAddCondolence,
    OnAddFlower,
    OnAddCandle,
    OnSendCard,
    OnSendBouquet
  }: {
    person: Person,
    options: {
      floristUrl?: string
      postcardUrl?: string
    }
    showInteractions: boolean,
    manualHeight?: number,
    className?: string,
    isOpen: boolean,
    OnSetMobileState?: (state: boolean) => void,
    OnAddCondolence?: () => void,
    OnAddFlower?: () => void,
    OnAddCandle?: () => void,
    OnSendCard?: () => void,
    OnSendBouquet?: () => void,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && manualHeight) {
      const htmlElement = ref.current as HTMLElement
      htmlElement.style.position = `absolute`;
      htmlElement.style.top = `${manualHeight}px`;
    }
  }, [manualHeight]);

  const {isMobile} = useWindowSize()
  const isPlatformHack = person.options?.platform_hack === true

  return <div className={styles.container}  ref={ref}>
    <div className={`${className || ''} ${styles.actions} ${isOpen ? styles.open : ''} ${showInteractions ? '' : styles.hideInteractions}`} >

      <div>
        {showInteractions && <>
          <button className={`${styles.btn} ${styles.btnDark}`}
                  onClick={() => OnAddCondolence && OnAddCondolence()}>
            <RoundIcon icon={<Pen/>}/>
            <span><strong>{isPlatformHack ? 'Reactie achterlaten' : 'Condoleren'}</strong></span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>

          <button className={`${styles.btn} ${styles.btnDark} md:!hidden`} onClick={() => OnAddFlower && OnAddFlower()}>
            <RoundIcon icon={<Flower/>}/>
            <span>Plaats een bloem</span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
          <button className={`${styles.btn} ${styles.btnDark} ${!isPlatformHack && 'md:!hidden'}`} onClick={() => OnAddCandle && OnAddCandle()}>
            <RoundIcon icon={<Candle/>}/>
            <span>{isPlatformHack ? 'Kaarsje aansteken' : 'Brand een kaars'}</span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </>
      }

      <div className={'md:mb-5'}></div>

        {options.postcardUrl && <a className={`${styles.btn}`} href={options.postcardUrl} target={'_blank'}>
            <RoundIcon icon={<Pen/>}/>
            <span>Stuur een&nbsp;<strong>kaartje</strong></span>
            <i className="fa-solid fa-chevron-right"></i>
        </a>}

        {options.floristUrl && <a className={`${styles.btn}`} href={options.floristUrl} target={'_blank'}>
          <RoundIcon icon={<Flower/>}/>
          <span><strong>Boeket</strong>&nbsp;laten bezorgen</span>
          <i className="fa-solid fa-chevron-right"></i>
        </a>}

        <button className={`md:!hidden ${styles.btn} ${styles.btnLink} justify-center`} onClick={() => OnSetMobileState && OnSetMobileState(false)}>Sluiten</button>


        {!isPlatformHack && <div className={`${styles.btn} my-5 !hidden md:!block`}><SharePerson person={person} /></div>}

        {/*{person.obituary_type === 0 && !isMobile &&*/}
        {/*  <div className={`${styles.btn} ${styles.btnLink} ${styles.commercial}`}><Commercial*/}
        {/*    type={CommercialType.MediumRectangle} top/></div>*/}
        {/*}*/}
      </div>

    </div>
    {showInteractions && <div className={styles.toggle} onClick={() => OnSetMobileState && OnSetMobileState(true)}>
      {isPlatformHack ? 'Reactie achterlaten' : 'Condoleance achterlaten'}
    </div>}


  </div>
}
